import {
  filterTrandByLoad,
  genClassName
} from '@/commons/kind'
import { dateFormat } from '@/commons/utils'

export const filterTag = (content) => {
  var tagNames = content.match(/\$(.*?)\$/g)
  var contents = []
  if (tagNames !== null) {
    var i = 0
    var l = tagNames.length
    var tagName = ''
    for (; i < l; i++) {
      tagName = tagNames[i]
      if (content.indexOf('<$>' + tagName + '<$>') === -1) {
        // 针对safari下在<$>前加一个空格
        content = content.replace(new RegExp('\\$' + tagName.replace(/(\$)/g, '').replace(/(\()/g, '（').replace(/(\))/g, '）') + '\\$', 'g'), '<$>' + tagName + ' <$>')
      }
    }
    let isBold = false
    content = content.split(/<\$>| <\$>/)
    if (content[0].indexOf('<b>') !== -1 && content[content.length - 1].indexOf('</b>') !== -1) {
      isBold = true
    }
    content.forEach((data, index) => {
      if (data) {
        let isTag = data.match(/(\$)/g)
        if (index === 0 && data === '<b>') {
          return false
        }
        contents.push({
          isTag: isTag && isTag.length === 2,
          data: data.replace(/(\$)/g, ''),
          isBold
        })
      }
    })
  }
  return contents
}

export const filterData = (data, isSocket, stockAffect) => {
  var type = data.type,
    time,
    startTime,
    content,
    star = 0,
    id,
    evaluate,
    evaluateClass,
    evaluateArry = [],
    date = '',
    showDate = false,
    formatDate = '',
    pubDate = '',
    resData = data.data,
    params = {}
  data.time = dateFormat(data.time, 'yyyy-MM-dd hh:mm:ss')
  if (type === 0) {
    id = data.time
    date = id.split(' ')[0]
    time = id.split(' ')[1]
    startTime = 'T_' + id.replace(/-/g, '').replace(/:/g, '').replace(/ /g, '') + '_0'
    content = resData.content.replace(/\n/ig, '<br/>')
    if (content.indexOf('<b>') !== -1) {
      if (content.match(/<([a-z]+)(\s*\w*?\s*=\s*".+?")*(\s*?>[\s\S]*?(<\/\1>)+|\s*\/>)/i) === null) {
        content = content.replace('<b>', '')
      }
    }
    // 以冒号为分隔，判断所有冒号前面相同的抬头的信息，鼠标浮动上去统一更改背景色
    var relevances = content.replace(/<\/?[^>]*>/g, '').split('：')
    var relevance = ''
    if (relevances.length >= 2) {
      if (relevances[0].length < 20 && relevances[0] !== '据外媒') {
        relevance = relevances[0]
      }
    }
    data.data.picLite = resData.pic ? resData.pic + '?x-oss-process=image/resize,m_lfit,w_500,limit_1/auto-orient,0/quality,q_80' : ''
    data.data.content = content
    data.relevance = relevance
    data.curRelevance = self.curRelevance
  } else if (type === 1 || type === 3) {
    star = resData.star
    var affect = resData.affect
    var actual = resData.actual
    var previous = resData.previous
    var consensus = resData.consensus
    previous = previous && parseFloat(resData.previous)
    consensus = consensus && parseFloat(resData.consensus)
    var unit = resData.unit
    var important = star > 2
    var testUnit = /^[\u4e00-\u9fa5]+$/.test(unit)
    const { statusClass, statusName } = genClassName(resData, stockAffect)

    id = data.time
    date = id.split(' ')[0]
    time = id.split(' ')[1]
    startTime = 'T_' + id.replace(/-/g, '').replace(/:/g, '').replace(/ /g, '') + '_' + star
    // 特殊处理股票数据不加单位，经济数据加单位
    // 调整成股票数据包含中文单位就增加单位

    content = (resData.type === 1)
    ? `${resData.name}${resData.time_period} ${resData.measure}${testUnit ? `（${unit}）` : ''}`
    : `${resData.country}${resData.time_period}${resData.name}${testUnit ? `（${unit}）` : ''}`

    data.important = important ? 1 : 0
    data.data.starNum = parseInt(star) * 20 + '%'
    data.data.pubDate = pubDate
    data.data.evaluate = statusName
    data.data.content = content
    data.data.evaluateClass = statusClass
    data.data.kind = '股票'
    data.data.trend = 1
    var percent = '%'
    if (unit && !testUnit) {
      if (unit === percent) {
        unit = ''
      } else {
        percent = ''
      }
      data.data.previous = previous !== null ? unit + previous + percent : ''
      data.data.consensus = consensus !== null ? unit + consensus + percent : ''
      data.data.actual = actual !== null ? unit + actual + percent : ''
    }
  }
  data.time_view = time
  data.startTime = startTime
  data.remark = data.remark || null
  if (data.remark) {
    data.remark = data.remark.filter(it => [
      'link', 'mage-text', 'video', 'market', 'content'
    ].includes(it.type))
  }
  params = data

  if (data.data.unit === '亿立方英尺') {
    // console.log(`亿立方英尺:${data.type}`, data, resData.type === 1)
  }
  if (type === 3) {
    return params
  }
  formatDate = date.split('-')
  params.isSocket = isSocket
  params.date = date
  params.formatDate = {
    m: formatDate[1],
    d: formatDate[2]
  }
  return params
}

export const dataSplicing = (datas) => {
  let list = []
  let i = 0
  let l = datas.length
  for (; i < l; i++) {
    var data = filterData(datas[i])
    if (!data) {
      continue
    } else {
      list.push(data)
    }
  }
  return list
}



// WEBPACK FOOTER //
// ./src/views/index/modules/filter.js